import React from 'react';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, LineSeries, DateTime, Legend, Tooltip, DataLabel } from '@syncfusion/ej2-react-charts';

import { lineCustomSeriesAItotalTrend, LinePrimaryXAxis, LinePrimaryYAxisReview } from '../../data/dummy';
import { useStateContext } from '../../contexts/ContextProvider';

const LineChartAItotal = ({ intent, chartKey }) => {
  const { currentMode } = useStateContext();
  const data = lineCustomSeriesAItotalTrend(intent);
  console.log(`chartKey: ${chartKey}`);
  const sanitizedKey = chartKey.replace(/[^\w-]/g, ""); // 특수문자 제거
  console.log(`sanitizedKey: ${sanitizedKey}`);
  return (
    <ChartComponent
      id={`line-chart-review-${sanitizedKey}`} // 특수 문자가 없는 id 설정
      height="420px"
      primaryXAxis={LinePrimaryXAxis}
      primaryYAxis={LinePrimaryYAxisReview}
      chartArea={{ border: { width: 0 } }}
      tooltip={{ enable: true }}
      background={currentMode === 'Dark' ? '#33373E' : '#fff'}
      legendSettings={{ background: 'white' }}
    >
      <Inject services={[LineSeries, DateTime, Legend, Tooltip, DataLabel]} />
      <SeriesCollectionDirective>
        {data.map((item, index) => (
          <SeriesDirective key={index} {...item} />
        ))}
      </SeriesCollectionDirective>
    </ChartComponent>
  );
};

export default LineChartAItotal;
